export default __webpack_public_path__ + "static/recent-events-504328415f454f7799d59b619852f165.png";